export default "__VITE_PUBLIC_ASSET__c37946d1__"